import debounce from 'lodash/debounce';
import first from 'lodash/first';
import * as React from 'react';
import ResizeObserver from 'resize-observer-polyfill';

export interface Dimensions {
    width: number;
    height: number;
}

export const useResizeObserver = <T extends HTMLElement>(ref: React.RefObject<T>): Dimensions | undefined => {
    const [dimensions, setDimensions] = React.useState<Dimensions>();

    React.useEffect(() => {
        const observeTarget = ref.current;

        // It's around 1/2 time of one frame (60fps) - it still provides performance boost while preserving smoothness
        const debounceTime = 8;
        const debounced = debounce((dim: Dimensions) => setDimensions(dim), debounceTime);

        const resizeObserver = new ResizeObserver(entries => {
            const entry = first(entries);

            if (entry) {
                debounced({
                    width: entry.contentRect.width,
                    height: entry.contentRect.height,
                });
            }
        });

        if (observeTarget) {
            resizeObserver.observe(observeTarget);
        }

        return () => {
            resizeObserver.disconnect();
        };
    }, [ref]);

    return dimensions;
};
